import { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import ChatPanel from "../features/chat/components/ChatPanel";
import { useChat } from "../features/chat/hooks/useChat";

const CHAT_ENABLED = process.env.REACT_APP_ENABLE_CHAT === "true";

const PublicLayout: React.FC = () => {
  const { token } = useAuth();
  const [chatOpen, setChatOpen] = useState(false);
  const chat = useChat();

  const showChat = CHAT_ENABLED && token;

  return (
    <div className="min-h-screen bg-surface-900 text-text-primary">
      {/* Top nav */}
      <header className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-3 bg-surface-900/80 backdrop-blur-sm border-b border-border/50">
        <Link to="/grid" className="flex items-center gap-2">
          <img src="/quantum-small.png" alt="TotalView" className="h-7 w-7" />
          <span className="text-lg font-semibold text-text-primary">
            TotalView
          </span>
        </Link>

        <div className="flex items-center gap-4">
          {/* Chat toggle in nav */}
          {showChat && (
            <button
              onClick={() => setChatOpen(!chatOpen)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-body-sm font-medium transition-colors ${
                chatOpen
                  ? "bg-quantum-500/20 text-quantum-400"
                  : "text-text-secondary hover:text-text-primary hover:bg-surface-700"
              }`}
              title="Toggle Assistant"
            >
              <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
              </svg>
              Assistant
              {chat.isStreaming && (
                <span className="h-2 w-2 rounded-full bg-green-400 animate-pulse" />
              )}
            </button>
          )}

          {token ? (
            <a href="/login" className="btn-primary text-body-sm px-4 py-1.5">
              Dashboard
            </a>
          ) : (
            <a href="/login" className="btn-primary text-body-sm px-4 py-1.5">
              Sign In
            </a>
          )}
        </div>
      </header>

      {/* Content: optional chat column + main */}
      <div className="pt-[52px] h-screen flex">
        {/* Chat column */}
        {showChat && chatOpen && (
          <aside className="w-80 flex-shrink-0 border-r border-border bg-surface-800 flex flex-col h-full">
            <ChatPanel
              messages={chat.messages}
              isStreaming={chat.isStreaming}
              onSend={chat.sendMessage}
              onStop={chat.stopStreaming}
              onClose={() => setChatOpen(false)}
              onClear={chat.clearMessages}
              embedded
            />
          </aside>
        )}

        {/* Main content fills remaining space */}
        <main className="flex-1 min-w-0 h-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default PublicLayout;
